import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useCookieConsent } from "@/hooks/useCookieConsent";

const GA_ID = "G-1GHED3TNXM";
const ADMIN_DEVICE_KEY = "is_admin_device";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const isAdminDevice = () => {
  try {
    return localStorage.getItem(ADMIN_DEVICE_KEY) === "1";
  } catch {
    return false;
  }
};

const loadGtag = () => {
  if (document.getElementById("ga-gtag-src")) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });

  const script = document.createElement("script");
  script.id = "ga-gtag-src";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
};

/**
 * Google Analytics 4 - ładowane tylko po akceptacji cookies (RODO).
 * Urządzenia admin (flaga is_admin_device) są wykluczone całkowicie.
 * page_view wysyłany ręcznie przy każdej zmianie trasy w SPA.
 */
export const GoogleAnalytics = () => {
  const { hasConsent } = useCookieConsent();
  const location = useLocation();
  const loadedRef = useRef(false);

  useEffect(() => {
    if (!hasConsent || isAdminDevice()) return;
    if (!loadedRef.current) {
      loadGtag();
      loadedRef.current = true;
    }
  }, [hasConsent]);

  useEffect(() => {
    if (!loadedRef.current || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};
